"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _timelineEvent = _interopRequireDefault(require("./timelineEvent"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var Timeline =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Timeline, _React$Component);

  function Timeline() {
    _classCallCheck(this, Timeline);

    return _possibleConstructorReturn(this, _getPrototypeOf(Timeline).apply(this, arguments));
  }

  _createClass(Timeline, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", {
        className: this.classes()
      }, this.eventRender());
    }
  }, {
    key: "classes",
    value: function classes() {
      return "timeline horizontal timeline-".concat(this.props.context);
    }
  }, {
    key: "eventRender",
    value: function eventRender() {
      var reversedChildren = _react.default.Children.toArray(this.props.children).reverse();

      var foundCurrent = false;
      var newChildren = []; // reverse the children to find the last current node
      // and then clone everything "before" that so they are
      // current.

      reversedChildren.forEach(function (c) {
        if (foundCurrent) {
          newChildren.push(_react.default.cloneElement(c, {
            status: _timelineEvent.default.statuses.complete
          }));
        } else if (c.props.status === _timelineEvent.default.statuses.current) {
          foundCurrent = true;
          newChildren.push(c);
        } else {
          newChildren.push(c);
        }
      });
      return newChildren.reverse().map(function (c, index) {
        return _react.default.createElement("div", {
          className: "event",
          key: index
        }, c);
      });
    }
  }]);

  return Timeline;
}(_react.default.Component);

Timeline.contexts = {
  primary: 'primary',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  info: 'info'
};
Timeline.defaultProps = {
  context: Timeline.contexts.primary
};
Timeline.propTypes = {
  children: _propTypes.default.arrayOf(_propTypes.default.instanceOf(_timelineEvent.default))
};
var _default = Timeline;
exports.default = _default;